import { h, Component } from 'preact';
import pure from 'utils/pure';
import Cookies from 'components/shared/cookies/cookies.js';
import RenderedPixels from 'components/shared/pixels/renderedPixels';
import Seo from 'components/shared/seo/seo.js';
import 'utils/pixels';
import { getStylingImagePath } from 'utils/utils';
import s from 'base/showtimes/showtimesApp.sss';


export default @pure class IEMessage extends Component {

	constructor(props) {
		super();
		this.state.appState = props.initialStore;
	}

	render(props) {
		const appData = props.appData;
		const copy = appData.copy;

		const defaultImageSrc = props.imageSrc || `${appData.urls.roots.imageRegion}/onesheet.jpg`;
		const imageSrc = getStylingImagePath(appData, 'onesheet', defaultImageSrc);
		const release = props.releaseDate || appData.meta.dates.release;
		const date = new Date(release);
		const releaseDate = date.toLocaleDateString();

		const browserUpdate = (
			<div class={s.IEMessage}>
				<img style="margin: auto; width: auto; height: 40vh;" src={imageSrc}/>
				<p style="padding: 20px">{`${copy.$RELEASE_DATE}: ${releaseDate}`}</p>
				<p style="padding: 20px">
					<small>{copy.$IE_BROWSER_MESSAGE}
						<a href={copy.$IE_BROWSER_LINK} target="_blank">
							{copy.$IE_BROWSER_LINK_WORD}
						</a>
					</small>
				</p>
			</div>
		);

		return (
			<div class={s.IEMessageContainer} ref={$ref => this.$container = $ref} id="app">
				<Cookies appData={appData} />
				<Seo />
				<RenderedPixels />
				{browserUpdate}
			</div>
		);
	}

}
